import { use } from 'react';

import { AuthContext, type AuthContextValue } from './AuthContext';

/**
 * Reads the authentication state.
 *
 * @returns the session and the operations that change it
 * @throws Error when called outside an AuthProvider, which is a wiring mistake rather than a
 *     runtime condition worth handling
 */
export function useAuth(): AuthContextValue {
  const context = use(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be called inside an AuthProvider');
  }
  return context;
}
